import { clientApi } from '@phoenix/clientApi';

export default {
  props: {
    resultPageHref: {
      type: String,
      default: '',
    },
    strapReference: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      searchValue: '',
      resultPageUrl: 'reference',
      isCompatible: null,
      watchExists: null,
      isLoading: false,
      hasRelatedStraps: null,
    };
  },

  computed: {
    canSubmitSearch() {
      return !!this.searchValue || this.isLoading;
    },

    searchResultLink() {
      const url = new URL(JSON.parse(this.resultPageHref));
      url.searchParams.set(this.resultPageUrl, this.searchValue);
      return url.href;
    },

    contactLink() {
      return window.route('contact_page');
    },
  },

  methods: {
    async getSearchAsYouTypeWatchRef(query) {
      let requestResult;

      try {
        requestResult = await clientApi.get(window.route('api.search.watchRef'), {
          params: {
            query,
          },
        });
      } catch {
        return false;
      }

      const data = requestResult?.data?.data;
      if (!data) {
        return false;
      }

      return data;
    },

    async checkReference() {
      if (!this.canSubmitSearch) {
        return;
      }

      this.isLoading = true;
      this.isCompatible = null;

      try {
        const { data } = await clientApi.get(window.route('api.search.compatibilityCheck'), {
          params: {
            watchReference: this.searchValue,
            strapReference: this.strapReference,
          },
        });

        this.isCompatible = data.data.isCompatible;
        this.watchExists = data.data.watchExists;
        this.hasRelatedStraps = data.data.hasRelatedStraps;
      } catch {
        this.isCompatible = false;
        this.watchExists = false;
        this.hasRelatedStraps = false;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
